import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getGame } from './GameRegistry';
import { useAuth } from './hooks/useAuth';
import { useSocket } from './hooks/useSocket';
import { useLobby } from './hooks/useLobby';
import { BACKEND_URL } from './utils';
import LeftMenu from '../components/LeftMenu';
import AuthModal from '../components/AuthModal';
import StatsModal from '../components/StatsModal';

function GameShell() {
  const { slug } = useParams();
  const game = getGame(slug);

  if (!game) return <Navigate to="/" replace />;

  return <GameShellInner key={slug} game={game} />;
}

function GameShellInner({ game }) {
  const auth = useAuth();
  const { socket, playerId } = useSocket();
  const lobby = useLobby(socket, playerId);

  const { menuProps, renderBoard, className, gameboardClassName } = game.useOrchestrator(lobby, auth);

  return (
    <div className={`App ${className || ''}`}>
      {lobby.error && (
        <div className="error-message">
          {lobby.error}
          <button onClick={() => lobby.setError('')}>×</button>
        </div>
      )}

      <div className="app-layout">
        <LeftMenu
          game={game}
          gameMode={lobby.gameMode}
          gameState={lobby.gameState}
          countdownValue={lobby.countdownValue}
          gameSeed={lobby.gameSeed}
          lobbyCode={lobby.lobbyCode}
          players={lobby.players}
          wins={lobby.wins}
          playerId={playerId}
          hostId={lobby.hostId}
          startError={lobby.startError}
          pendingInvite={lobby.pendingInvite}
          onAcceptInvite={lobby.acceptInvite}
          onDeclineInvite={lobby.declineInvite}
          onCreateLobby={lobby.createLobby}
          onJoinLobby={lobby.joinLobby}
          authUser={auth.authUser}
          onLogin={auth.openLoginModal}
          onLogout={auth.handleLogout}
          onOpenStats={() => auth.setStatsModalOpen(true)}
          backendUrl={BACKEND_URL}
          authToken={auth.authToken}
          {...menuProps}
        />

        <AuthModal
          isOpen={auth.authModalOpen}
          onClose={() => auth.setAuthModalOpen(false)}
          onLogin={auth.handleLogin}
        />

        <StatsModal
          isOpen={auth.statsModalOpen}
          onClose={() => auth.setStatsModalOpen(false)}
          backendUrl={BACKEND_URL}
          authToken={auth.authToken}
          authUser={auth.authUser}
        />

        <div className={`gameboard-area ${gameboardClassName || ''}`}>
          {renderBoard()}
        </div>
      </div>
    </div>
  );
}

export default GameShell;
